import { render } from "./Manual.vue?vue&type=template&id=1832f8a5&ts=true"
import script from "./Manual.vue?vue&type=script&lang=ts"
export * from "./Manual.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__